"use client";

import React from "react";
import { Progress } from "@/components/ui/progress";
import * as Icons from "lucide-react";

interface EventStatsProps {
  paidCount: number;
  maxParticipants: number;
}

export function EventStats({ paidCount, maxParticipants }: EventStatsProps) {
  const percentage = maxParticipants > 0 ? (paidCount / maxParticipants) * 100 : 0;

  return (
    <div className="px-4 py-2 space-y-2">
      <div className="flex items-center justify-between text-xs font-medium text-muted-foreground">
        <span className="flex items-center gap-1">
          <Icons.Ticket className="h-3 w-3" />
          {paidCount} / {maxParticipants} Plätze
        </span>
        <span className="text-primary">{Math.round(percentage)}%</span>
      </div>
      <Progress value={percentage} />
    </div>
  );
}
